import gateway from '../../gateway/gateway'
import { notify } from '../../redux/notifications'
import { messages } from './messages'
import { captureException } from '../../sentry-config'

const setActivities = activities => ({
  type: 'SET_ACTIVITIES',
  activities,
})

const addActivity = activity => ({
  type: 'ADD_ACTIVITY',
  activity: {
    type: 'Success',
    record: activity,
  },
})

const updateActiveSuccessStatus = active_success => ({
  type: 'UPDATE_INTERLOCUTOR_ACTIVE_SUCCESS',
  active_success,
})

const sendMarkAsSuccessRequest = (dispatch, id, successCallback) => {
  gateway.activities
    .success(id)
    .then(json => successCallback(json))
    .catch(captureException)
}

export const markAsSuccess = id => dispatch => {
  sendMarkAsSuccessRequest(dispatch, id, json => {
    dispatch(addActivity(json))
    dispatch(updateActiveSuccessStatus(true))
    dispatch(notify(messages.textNotifyMarkPersonAsSuccess))
    return true
  })
}

const findPersonActivities = (dispatch, id, successCallback) => {
  gateway.activities
    .allForUserId(id)
    .then(json => successCallback(json))
    .catch(captureException)
}

export const fetchActivities = id => dispatch => {
  findPersonActivities(dispatch, id, json => {
    dispatch(setActivities(json))
    return true
  })
}
